/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Birth_Date_Under_18Inputs */

const en_signup_birth_date_under_18 = /** @type {(inputs: Signup_Birth_Date_Under_18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must be at least 18 to create an account.`)
};

const pl_signup_birth_date_under_18 = /** @type {(inputs: Signup_Birth_Date_Under_18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aby założyć konto, musisz mieć co najmniej 18 lat.`)
};

/**
* | output |
* | --- |
* | "You must be at least 18 to create an account." |
*
* @param {Signup_Birth_Date_Under_18Inputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const signup_birth_date_under_18 = /** @type {((inputs?: Signup_Birth_Date_Under_18Inputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Birth_Date_Under_18Inputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_signup_birth_date_under_18(inputs)
	return en_signup_birth_date_under_18(inputs)
});